import { useEffect } from "react";
import { Button } from "~/components/ui/button";
import { Link, useSearchParams } from "@remix-run/react";

const ERROR_PAGE_MODES = {
  default: {
    primaryText: "Interested in our wine club? Checkout out our homepage.",
    primaryButtonText: "Homepage",
    primaryButtonLink: "/",
  },
  "retake-quiz": {
    primaryText: "Want to start fresh? Retake our wine quiz.",
    primaryButtonText: "Retake Quiz",
    primaryButtonLink: "/a/ui/quiz",
  },
};

export function ErrorPage({ message }) {
  const [searchParams] = useSearchParams();

  const displayMode = searchParams?.get("mode") || "default";
  const modeConfig = ERROR_PAGE_MODES[displayMode] || ERROR_PAGE_MODES.default;
  const defaultMessage =
    "Sorry, we could not find the page you were looking for.";
  const displayMessage = message || defaultMessage;

  // Clean up localStorage on error page mount as a recovery measure.
  // This error page is shown when the app encounters an unrecoverable state,
  // often due to corrupted or invalid data in localStorage (introSettings/introSession).
  // Clearing these values allows users to start fresh instead of being stuck in an error loop.
  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.removeItem("introSession");
      localStorage.removeItem("introSettings");
    }
  }, []);

  return (
    <div className="tw:flex tw:flex-col tw:items-start tw:max-w-[1170px] tw:mx-auto tw:w-full">
      <div className="tw:flex-1 tw:flex tw:flex-col tw:items-center tw:justify-center tw:py-16">
        <div className="tw:text-left tw:space-y-8">
          <h1 className="tw:text-2xl tw:md:text-3xl tw:font-medium tw:text-gray-900">
            {displayMessage}
          </h1>

          <div className="tw:space-y-4 tw:pt-4">
            <p className="tw:text-base tw:md:text-lg tw:text-gray-700">
              {modeConfig.primaryText}
            </p>
            <Button size="lg" asChild>
              <Link to={modeConfig.primaryButtonLink}>
                {modeConfig.primaryButtonText}
              </Link>
            </Button>
          </div>

          <div className="tw:space-y-4">
            <p className="tw:text-base tw:md:text-lg tw:text-gray-700">
              Buy bottles or bundles of world-class wine in our Wine Store.
            </p>
            <Button size="lg" asChild>
              <Link to="/collections">Wine Store</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
